import React from 'react';

import {observer} from 'mobx-react';
import {GameCenterHeaderModuleProps} from "../../../models/game-center-header-module.props";
import {RectangleLabel} from "../../../../../../../core/components/misc/rectangle-label/rectangle-label";
import {PreciseGameTime} from "../../../../../../../core/components/precise-game-time/precise-game-time";
import styles from "./../../../styles/game-center-header-status.module.scss";
import classNames from "classnames";

export class GameCenterHeaderModuleDetailsStatusGameTimeLabelProps extends GameCenterHeaderModuleProps {
}

export const GameCenterHeaderModuleDetailsStatusGameTimeLabel = observer(({controller}: GameCenterHeaderModuleDetailsStatusGameTimeLabelProps) => {
  const {state} = controller;
  const {device} = state;

  const {
    displayStatusText,
    displayGameTime,
    statusContainerAnimation,
    showStatusDescription,
    isLive,
    statusText,
    preciseGameTime,
    shouldRenderPreciseGameTime,
    gameTime
  } = state;

  const shouldRenderRectangle: Boolean = displayStatusText || displayGameTime

  const statusDescriptionProps = {
    className: classNames(statusContainerAnimation),
    isVisible: showStatusDescription,
    device: device,
    colorLabelClassName: classNames(styles.label, {[styles.live]: isLive})
  };

  const preciseGameTimeProps = {
    minutes: preciseGameTime?.minutes,
    seconds: preciseGameTime?.seconds,
    countForward: preciseGameTime?.countForward,
    countBackward: preciseGameTime?.countBackward,
    autoProgress: preciseGameTime?.autoProgress,
  }

  return (
    shouldRenderRectangle ? <RectangleLabel {...statusDescriptionProps}>
      {
        displayStatusText ? statusText : null
      }
      {
        (displayGameTime && (shouldRenderPreciseGameTime ?
          <PreciseGameTime {...preciseGameTimeProps}/> : gameTime))
      }
    </RectangleLabel> : null
  );
});
